
$(document).ajaxStart(function(e) {
    var spinner = $('[data-spinner]').data('spinner');
    $('[data-spinner="' + spinner + '"]').show();
});
